import Tooltip from "@mui/material/Tooltip";

const VuiTooltip = ({ title, children }) => (
  <Tooltip
    title={title}
    arrow
    placement="top"
    enterDelay={300}
    componentsProps={{
      tooltip: {
        sx: {
          backgroundColor: "rgba(255,255,255,0.95)",
          color: "#1a1a1a",
          fontSize: "11px",
          fontWeight: 500,
          padding: "6px 8px",
          borderRadius: "6px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
        },
      },
      arrow: {
        sx: {
          color: "rgba(255,255,255,0.95)",
        },
      },
    }}
  >
    {children}
  </Tooltip>
);

export default VuiTooltip;
